import { Link } from 'react-router-dom';
import ArticleLayout from './components/ArticleLayout';

export default function VersandPage() {
  return (
    <ArticleLayout
      title="OOPBUY Versand nach Deutschland – Der komplette Guide 2026"
      description="Alles über OOPBUY Versand nach Deutschland, Österreich und die Schweiz. Vergleiche DHL, EMS und andere Versandmethoden, erfahre alles über Lieferzeiten, Zollgebühren und wie du Versandkosten sparst."
      heroImage="https://readdy.ai/api/search-image?query=cardboard%20shipping%20boxes%20neatly%20stacked%20on%20warm%20beige%20surface%20with%20world%20map%20concept%20in%20background%2C%20minimalist%20logistics%20photography%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20tones%2C%20clean%20European%20aesthetic%2C%20modern%20ecommerce%20shipping%20concept&width=1600&height=600&seq=article-hero-versand&orientation=landscape"
      heroImageAlt="OOPBUY Versand Guide"
      pageUrl="/oopbuy-versand"
      relatedArticles={[
        { title: 'OOPBUY Sicherheit Guide', path: '/oopbuy-sicherheit' },
        { title: 'OOPBUY Spreadsheet Guide', path: '/oopbuy-spreadsheet-guide' },
        { title: 'OOPBUY Kosten sparen', path: '/oopbuy-kosten-sparen' },
        { title: 'OOPBUY für Anfänger', path: '/oopbuy-anfaenger' },
      ]}
    >
      <section className="mb-10">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">OOPBUY Versand nach Deutschland im Überblick</h2>
        <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
          Der Versand von OOPBUY Bestellungen nach <strong>Deutschland, Österreich und in die Schweiz</strong> ist ein Thema, das viele Käufer beschäftigt. Dieser Guide erklärt dir alle wichtigen Versandoptionen, damit du die beste Wahl für deine Bestellung treffen kannst.
        </p>
        <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
          Mehr zu den Grundlagen findest du im <Link to="/oopbuy-spreadsheet-guide" className="text-accent-600 hover:text-accent-700 underline whitespace-nowrap">OOPBUY Spreadsheet Guide</Link>.
        </p>
      </section>

      <section className="mb-10">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">Versandmethoden im Vergleich</h2>
        <div className="overflow-x-auto mb-6">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-background-300/60">
                <th className="text-left py-3 px-4 text-foreground-900 font-semibold whitespace-nowrap">Methode</th>
                <th className="text-left py-3 px-4 text-foreground-900 font-semibold whitespace-nowrap">Lieferzeit</th>
                <th className="text-left py-3 px-4 text-foreground-900 font-semibold whitespace-nowrap">Kosten</th>
                <th className="text-left py-3 px-4 text-foreground-900 font-semibold whitespace-nowrap">Tracking</th>
                <th className="text-left py-3 px-4 text-foreground-900 font-semibold whitespace-nowrap">Empfehlung</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-background-200/70">
                <td className="py-3 px-4 text-foreground-800 font-medium whitespace-nowrap">DHL</td>
                <td className="py-3 px-4 text-foreground-600 whitespace-nowrap">7-14 Tage</td>
                <td className="py-3 px-4 text-foreground-600 whitespace-nowrap">Mittel</td>
                <td className="py-3 px-4 text-foreground-600 whitespace-nowrap">Sehr gut</td>
                <td className="py-3 px-4"><span className="inline-flex items-center gap-1 text-accent-600 text-xs font-medium"><span className="w-3 h-3 flex items-center justify-center"><i className="ri-star-fill text-xs"></i></span> Beste Wahl</span></td>
              </tr>
              <tr className="border-b border-background-200/70">
                <td className="py-3 px-4 text-foreground-800 font-medium whitespace-nowrap">EMS</td>
                <td className="py-3 px-4 text-foreground-600 whitespace-nowrap">10-20 Tage</td>
                <td className="py-3 px-4 text-foreground-600 whitespace-nowrap">Günstig</td>
                <td className="py-3 px-4 text-foreground-600 whitespace-nowrap">Gut</td>
                <td className="py-3 px-4"><span className="inline-flex items-center gap-1 text-foreground-500 text-xs font-medium">Gut für Budget</span></td>
              </tr>
              <tr className="border-b border-background-200/70">
                <td className="py-3 px-4 text-foreground-800 font-medium whitespace-nowrap">EUB</td>
                <td className="py-3 px-4 text-foreground-600 whitespace-nowrap">15-30 Tage</td>
                <td className="py-3 px-4 text-foreground-600 whitespace-nowrap">Sehr günstig</td>
                <td className="py-3 px-4 text-foreground-600 whitespace-nowrap">Eingeschränkt</td>
                <td className="py-3 px-4"><span className="inline-flex items-center gap-1 text-foreground-500 text-xs font-medium">Kleine Pakete</span></td>
              </tr>
              <tr>
                <td className="py-3 px-4 text-foreground-800 font-medium whitespace-nowrap">FedEx/UPS</td>
                <td className="py-3 px-4 text-foreground-600 whitespace-nowrap">5-10 Tage</td>
                <td className="py-3 px-4 text-foreground-600 whitespace-nowrap">Hoch</td>
                <td className="py-3 px-4 text-foreground-600 whitespace-nowrap">Exzellent</td>
                <td className="py-3 px-4"><span className="inline-flex items-center gap-1 text-foreground-500 text-xs font-medium">Express</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">Zoll nach Deutschland – Was du wissen musst</h2>
        <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
          Bei der Einfuhr von Waren nach Deutschland gelten bestimmte <strong>Zollbestimmungen und Freigrenzen</strong>. Informiere dich vorab, um unangenehme Überraschungen zu vermeiden. Die wichtigsten Punkte im Überblick:
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
          <div className="p-4 bg-background-100 rounded-lg">
            <h3 className="text-sm font-semibold text-foreground-900 mb-2">Warenwert unter 150 €</h3>
            <p className="text-foreground-600 text-xs leading-relaxed">Bei Bestellungen unter 150 Euro Warenwert fallen in der Regel keine zusätzlichen Einfuhrabgaben an. Trotzdem kann die Einfuhrumsatzsteuer erhoben werden.</p>
          </div>
          <div className="p-4 bg-background-100 rounded-lg">
            <h3 className="text-sm font-semibold text-foreground-900 mb-2">Warenwert über 150 €</h3>
            <p className="text-foreground-600 text-xs leading-relaxed">Ab 150 Euro können Zollgebühren anfallen. Die Höhe hängt von der Produktkategorie ab. Informiere dich vor der Bestellung über die spezifischen Sätze.</p>
          </div>
        </div>
      </section>

      <section className="mb-10">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">Versandkosten sparen – Tipps & Tricks</h2>
        <div className="space-y-3">
          <div className="flex items-start gap-3 p-3 bg-background-100 rounded-lg">
            <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center"><i className="ri-check-line text-accent-500"></i></span>
            <p className="text-foreground-600 text-sm"><strong>Sammelbestellungen aufgeben:</strong> Mehrere Artikel in einem Paket zu bündeln reduziert die Gesamtversandkosten erheblich.</p>
          </div>
          <div className="flex items-start gap-3 p-3 bg-background-100 rounded-lg">
            <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center"><i className="ri-check-line text-accent-500"></i></span>
            <p className="text-foreground-600 text-sm"><strong>Saisonale Aktionen nutzen:</strong> Viele Plattformen bieten zu bestimmten Zeiten reduzierte oder kostenlose Versandoptionen an.</p>
          </div>
          <div className="flex items-start gap-3 p-3 bg-background-100 rounded-lg">
            <span className="w-5 h-5 flex-shrink-0 flex items-center justify-center"><i className="ri-check-line text-accent-500"></i></span>
            <p className="text-foreground-600 text-sm"><strong>Geduld haben:</strong> Langsamere Versandmethoden wie EUB sind deutlich günstiger — ideal, wenn du es nicht eilig hast.</p>
          </div>
        </div>
        <p className="text-foreground-600 text-sm mt-4">
          Noch mehr Spartipps findest du in unserem <Link to="/oopbuy-kosten-sparen" className="text-accent-600 hover:text-accent-700 underline whitespace-nowrap">OOPBUY Kosten sparen Guide</Link>.
        </p>
      </section>
    </ArticleLayout>
  );
}